/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { Column } from "../../../../common/commonComponents/lotDetailsTable";
import { PAMediaPlateData } from "../mediaRemoval.types";

const getPAMediaPlateColumns = (
	t: any,
	handleSelectPlate: (plateId: string) => void,
): Column[] => [
	{
		header: "",
		key: "",
		render: (row: PAMediaPlateData) => (
			<>
				<input
					type="checkbox"
					onChange={() => handleSelectPlate(row.container_id)}
					className="w-4 h-4 rounded border-slate-300 text-[#FF7043] focus:ring-[#FF7043]"
				/>
			</>
		),
	},
	{
		header: t("postAutoclaveProcess.mediaRemoval.columns.plateId"),
		key: "id",
		render: (row: PAMediaPlateData) => (
			<>
				<span className="text-xs font-bold text-slate-700">{row.container_serial_number}</span>
			</>
		),
	},
	{
		header: t("postAutoclaveProcess.mediaRemoval.columns.location"),
		key: "id",
		render: (row: PAMediaPlateData) => (
			<>
				<span className="text-xs font-medium text-slate-500">
					{row.autoclave_area_name}
				</span>
			</>
		),
	},
	{
		header: t("postAutoclaveProcess.mediaRemoval.columns.status"),
		key: "id",
		render: (row: PAMediaPlateData) => (
			<>
				<span className="text-xs font-medium text-slate-500">
					{row.plate_status}
				</span>
			</>
		),
	},
];

export default getPAMediaPlateColumns;
